module.exports = __webpack_public_path__ + "static/media/4_r_holst_90.21_68.06.9a75d1c4.png";